/**
 * What to call an uploaded file's format, in one place.
 *
 * THE BUG THIS EXISTS TO FIX. Four call sites each did their own
 * `mimeType.split('/').pop()` and got four different wrong answers.
 * `application/postscript` rendered as "POSTSCRIPT" in the review stage and
 * the library detail, and as "POST" on the review thumb, where a four-
 * character slice cut it off. An Illustrator file rendered as "PDF".
 *
 * WHY AI FILES SAY PDF, AND WHY THAT IS ONLY HALF RIGHT. Illustrator writes
 * .ai files as PDFs, so the magic-byte sniffer classifies them as
 * `application/pdf` and is correct to do so: the bytes are what matters, not
 * the extension somebody typed. But the sponsor sent an .ai file, the reviewer
 * is looking for an .ai file, and telling them it is a PDF loses the identity
 * they actually care about. So the mime type decides how the file is HANDLED
 * and the original filename decides what it is CALLED. The sniffing is right
 * and is not changed.
 *
 * A label is at most four characters, because it renders inside a small badge
 * on a thumbnail. Every value below already fits, so nothing is ever cut off
 * mid-word the way "POST" was.
 */

const BY_MIME: Record<string, string> = {
  'image/svg+xml': 'SVG',
  'application/pdf': 'PDF',
  'application/postscript': 'EPS',
  'image/png': 'PNG',
  'image/jpeg': 'JPG',
};

/** Formats that stay sharp at any size, which is what the review screen wants
 *  to tell a reviewer about. AI is a PDF and counts. */
const VECTOR_MIME = new Set(['image/svg+xml', 'application/pdf', 'application/postscript']);

/**
 * The badge for one file.
 *
 * `filename` is optional, and only ever used to recover the .ai identity that
 * the mime type cannot carry. Everything else is decided by the mime type
 * alone, which is the value that came from sniffing the bytes.
 */
export function formatLabel(mimeType: string, filename?: string | null): string {
  if (mimeType === 'application/pdf' && isIllustrator(filename)) return 'AI';
  return BY_MIME[mimeType] ?? 'FILE';
}

/** Whether the sponsor sent an Illustrator file. The extension is the only
 *  record of it: the bytes are a PDF and say so. */
export function isIllustrator(filename?: string | null): boolean {
  return typeof filename === 'string' && /\.ai$/i.test(filename.trim());
}

export function isVector(mimeType: string): boolean {
  return VECTOR_MIME.has(mimeType);
}
